import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, ElementRef, DoCheck } from '@angular/core';
import { FormBuilder, Validators, NgControl, NgForm, FormGroupDirective } from '@angular/forms';
import { MatFormFieldControl, ErrorStateMatcher } from '@angular/material';
import { FocusMonitor } from '@angular/cdk/a11y';
import { Subject } from 'rxjs';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { NumberValidator } from '@awp/forms';
import { DateUtils } from '@awp/core/utils';
import { _AwpComponentMixinBase } from '../custom-base.component';
var DateInputComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DateInputComponent, _super);
    function DateInputComponent(ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, formBuilder, focusMonitor, elRef) {
        var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
        _this.formBuilder = formBuilder;
        _this.focusMonitor = focusMonitor;
        _this.elRef = elRef;
        _this.id = "awp-date-input-" + DateInputComponent.nextId++;
        _this.describedBy = '';
        _this.controlType = 'aws-date-input';
        _this.stateChanges = new Subject();
        _this.focused = false;
        _this._required = false;
        _this._disabled = false;
        _this._value = null;
        _this.dayPlaceHolder = '';
        _this.monthPlaceHolder = '';
        _this.yearPlaceHolder = '';
        if (_this.ngControl != null) {
            _this.ngControl.valueAccessor = _this;
        }
        _this.focusMonitor
            .monitor(elRef.nativeElement, true)
            .pipe(untilDestroyed(_this))
            .subscribe(function (origin) {
            _this.focused = !!origin;
            _this.stateChanges.next();
        });
        _this.form = _this.formBuilder.group({
            day: [null, [Validators.required, Validators.pattern(/[0-9]{1,2}/)]],
            month: [null, [Validators.required, Validators.pattern(/[0-9]{1,2}/), NumberValidator.range(1, 12)]],
            year: [null, [Validators.required, Validators.pattern(/[12][0-9]{3}/)]],
        }, {
            updateOn: 'blur'
        });
        return _this;
    }
    DateInputComponent.prototype.ngOnInit = function () {
        var e_1, _a;
        var _this = this;
        var _loop_1 = function (controlName) {
            var control = this_1.form.get(controlName);
            control.valueChanges
                .pipe(untilDestroyed(this_1))
                .subscribe(function (value) {
                if (value && value.length === 1) {
                    control.setValue(value.padStart(2, '0'));
                }
            });
        };
        var this_1 = this;
        try {
            // pad to 2 digits
            for (var _b = tslib_1.__values(['day', 'month']), _c = _b.next(); !_c.done; _c = _b.next()) {
                var controlName = _c.value;
                _loop_1(controlName);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.form.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(function (p) {
            _this.notifyChanged(p);
        });
    };
    DateInputComponent.prototype.ngOnDestroy = function () {
        this.stateChanges.complete();
        this.focusMonitor.stopMonitoring(this.elRef.nativeElement);
    };
    DateInputComponent.prototype.ngDoCheck = function () {
        if (this._onTouched != null) {
            // if you tab past all three date controls, then mark the control as touched
            if (this.form.get('day').touched && (this.form.get('month').touched && this.form.get('year').touched)) {
                this._onTouched();
            }
        }
        if (this.ngControl != null) {
            // triggers validation
            this.updateErrorState();
        }
    };
    DateInputComponent.prototype.isDateEntryComplete = function () {
        return (this.form.get('day').touched || this.form.get('day').value)
            && (this.form.get('month').touched || this.form.get('month').value)
            && (this.form.get('year').touched || this.form.get('year').value);
    };
    DateInputComponent.prototype.notifyChanged = function (value) {
        try {
            var selectedDate = DateUtils.parseDate(value);
            var valueChanged = selectedDate === null || this.value !== selectedDate;
            if (valueChanged) {
                this.value = selectedDate;
                this.stateChanges.next();
                if (this._onChange != null) {
                    this._onChange(selectedDate);
                    if (this.isDateEntryComplete()) {
                        this._onTouched();
                    }
                }
            }
        }
        catch (err) {
            console.error('Error converting date value', err);
        }
    };
    //#region ControlValueAccessor
    DateInputComponent.prototype.writeValue = function (value) {
        if (this.form == null) {
            return;
        }
        if (value != null) {
            if (value instanceof Date) {
                var theDate = value;
                this.form.patchValue({
                    day: theDate.getDate().toString().padStart(2, '0'),
                    month: (theDate.getMonth() + 1).toString().padStart(2, '0'),
                    year: theDate.getFullYear(),
                }, { emitEvent: false });
            }
            else {
                this.form.patchValue(value, { emitEvent: false });
            }
        }
        else {
            this.form.reset({}, { emitEvent: false });
        }
    };
    DateInputComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    DateInputComponent.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    DateInputComponent.prototype.setDisabledState = function (isDisabled) {
        isDisabled ? this.form.disable() : this.form.enable();
    };
    //#endregion
    // This doesn't seem to be used...
    DateInputComponent.prototype.isError = function (value) {
        if ((value.day === "" || value.day == null) &&
            (value.month === "" || value.month == null) &&
            (value.year === "" || value.year == null)) {
            return this.required;
        }
        if (!/[0-9]{1,2}/.test(value.day))
            return true;
        if (!/[0-9]{1,2}/.test(value.month))
            return true;
        if (!/[0-9]{4}/.test(value.year))
            return true;
        return false;
    };
    Object.defineProperty(DateInputComponent.prototype, "empty", {
        get: function () {
            return !this.form.value || (!this.form.value.day && !this.form.value.month && !this.form.value.year);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateInputComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (selectedDate) {
            this._value = selectedDate;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateInputComponent.prototype, "disabled", {
        get: function () { return this._disabled; },
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
            this._disabled ? this.form.disable() : this.form.enable();
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateInputComponent.prototype, "placeholder", {
        get: function () {
            return this._placeholder;
        },
        set: function (plh) {
            this._placeholder = plh;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateInputComponent.prototype, "required", {
        get: function () {
            return this._required;
        },
        set: function (req) {
            this._required = coerceBooleanProperty(req);
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    DateInputComponent.prototype.setValue = function () {
        this.stateChanges.next();
    };
    DateInputComponent.prototype.setDescribedByIds = function (ids) {
        this.describedBy = ids.join(' ');
    };
    DateInputComponent.prototype.onContainerClick = function (event) {
        if (event.target.tagName.toLowerCase() !== 'input') {
            this.elRef.nativeElement.querySelector('input').focus();
        }
    };
    Object.defineProperty(DateInputComponent.prototype, "shouldLabelFloat", {
        get: function () {
            return this.focused || !this.empty;
        },
        enumerable: true,
        configurable: true
    });
    DateInputComponent.nextId = 0;
    return DateInputComponent;
}(_AwpComponentMixinBase));
export { DateInputComponent };
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}
